module.exports = __webpack_public_path__ + "static/media/Pouť-95-MCoppa-8.f6f0556c.jpg";